import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { env } from '~/commons/config';
import ListResource from './ListResource.jsx';
import { useCompetitions } from '../../contexts/Competitions';
import { resolveTo } from '~/commons/helpers';
import ModalAlert from '~/commons/components/ModalAlert.jsx';
import ModalConfirm from '~/commons/components/ModalConfirm.jsx';

const ListArticles = () => {
  const isSuperAdmin = env.user.roles.includes('superAdmin');
  const { refresh } = useCompetitions();
  const history = useHistory();
  const [locked, setLocked] = useState(null);
  const [unlock, setUnlock] = useState(null);

  return (
    <>
      <ListResource
        {...{
          searchable: true,
          api: 'api/quiz/competitions',
          sort: { createdAt: 1 },
          onRefresh: refresh,
          cols: [
            { key: 'refCode', sortable: true },
            { key: 'title', sortable: true },
            { key: 'duration', label: 'Duration (minutes)', sortable: true },
            {
              key: 'dates',
              getter: (v) => (
                v
                  ? [v[0], v.slice(-1)[0]]
                    .filter((d, i) => v.indexOf(d) === i)
                    .map((d) => moment(d).format('LL'))
                    .join(' - ')
                  : ''
              ),
            },
            ...(isSuperAdmin ? [{
              key: 'locked',
              label: 'Locked',
              sortable: false,
              getter: (v,row) => { 
                return v ? (<button onClick={(evt)=>{
                  evt.stopPropagation();
                  evt.preventDefault();
                  setUnlock(row._id)
                }}>Unlock</button>) : ''; },
            }] : []),
          ],
          onRowClick:((row) => {
            fetch('api/quiz/competitions/'+row._id+'/lock')
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                history.push(resolveTo('', row._id));
              } else {
                setLocked(data.comp.locked);
              }
            }).catch((err) => {
              console.error('err', err);
            })
          })
        }}
      />
      <ModalAlert
        show={locked!=null}
        onHide={() => {setLocked(null);}}
      >
        {locked ? locked.by.name.full.en : ''} 正在使用中，請稍後再試。
      </ModalAlert>
      <ModalConfirm
        show={unlock!=null}
        onReject={() => setUnlock(null)}
        onConfirm={async () => {
          fetch('api/quiz/competitions/'+unlock+'/unlock')
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              window.location.reload();
            }
            setUnlock(null);
          }).catch((err) => {
            console.error('err', err);
            setUnlock(null);
          })
        }}
      >
        Are you sure you want to unlock?
      </ModalConfirm>
    </>
  );
};

export default ListArticles;
